import { PageBreadcrumbsWithLinks, PrimaryPageActions } from '@/components'
import { dashboardShellBreadcrumb } from '@/constants/adminPage'
import { PermissionTypes } from '@/constants/permissions'
import { usePermission } from '@/hooks/usePermission'
import React, { lazy, useState } from 'react'
import { useTranslation } from 'react-i18next'
import withSuspense from '@/helpers/suspense.helper'
import { PageBody, PageTitle, PageWrapper } from '@/components/PageWrapper'

const ViewSubscriptionPlans = withSuspense(lazy(() => import('./Components/ViewSubscriptionPlans')))
const AddEditSubscriptionPlan = withSuspense(lazy(() => import('./Components/AddEditSubscriptionPlan')))

const ManageSubscriptionPlans: React.FC = () => {
	const { t } = useTranslation()
	const { userHasPermission } = usePermission()
	const canManagePlans =
		userHasPermission(PermissionTypes.Permissions_SubscriptionPlans_Create) ||
		userHasPermission(PermissionTypes.Permissions_Tenants_View)
	const canCreate = canManagePlans
	const [reload, setReload] = useState(false)
	const [editId, setEditId] = useState<number | null>(null)
	const [showModal, setShowModal] = useState(false)

	const pageTitle = t('Manage.SubscriptionPlans.Heading', 'Subscription Plans')

	const onActionClick = (id: number, action: string) => {
		if (action === 'Add') {
			setEditId(null)
			setShowModal(true)
		}
		if (action === 'Edit') {
			setEditId(id)
			setShowModal(true)
		}
		if (action === 'Saved') {
			setShowModal(false)
			setReload((r) => !r)
		}
	}

	return (
		<>
	<PageBreadcrumbsWithLinks title={pageTitle} subNames={dashboardShellBreadcrumb(t('Manage.SubscriptionPlans.Breadcrumb', 'Subscription Plans'))} />

	<PageWrapper>
		<PageTitle
			actions={
				canCreate ? (
					<PrimaryPageActions>
						<button type="button" className="btn btn-primary" onClick={() => onActionClick(0, 'Add')}>
							<i className="ri-add-line" aria-hidden />
							{t('Manage.SubscriptionPlans.Add', 'Add Plan')}
						</button>
					</PrimaryPageActions>
				) : undefined
			}
		/>
		<PageBody>
					<ViewSubscriptionPlans onActionClick={onActionClick} reload={reload} />
				</PageBody>
			</PageWrapper>

			{showModal && <AddEditSubscriptionPlan planId={editId} onClose={() => setShowModal(false)} onSaved={() => onActionClick(0, 'Saved')} />}
		</>
	)
}

export default ManageSubscriptionPlans
